import { useState } from "react"
import { QrCodeIcon } from "@heroicons/react/20/solid"
import { Modal } from "./Modal"

export const QRCodeButton = () => {
  const [modalOpen, setModalOpen] = useState<boolean>(false)

  return (
    <>
      <button
        onClick={() => setModalOpen(true)}
        className="bg-brand-light text-white w-8 h-8 flex items-center justify-center rounded"
        type="button"
      >
        <QrCodeIcon className="h-5 w-5" />
      </button>
      <Modal open={modalOpen} setOpen={setModalOpen}>
        <div className="flex justify-center">
          <img src="./qr-code.png" alt="Home Affordability Calculator QR Code" />
        </div>
        <div className="mt-5 sm:mt-6">
          <button
            type="button"
            className="inline-flex w-full justify-center rounded-md border border-transparent bg-brand-light px-4 py-2 text-base font-medium text-white shadow-sm sm:text-sm"
            onClick={() => setModalOpen(false)}
          >
            CLOSE
          </button>
        </div>
      </Modal>
    </>
  )
}
